<template>
  <div class="app-wrapper">
    <router-view name="popup"></router-view>
    <lnb-wrapper></lnb-wrapper>
    <Header>
      <main-header></main-header>
    </Header> <!-- pooqzone 여부, headerTitle, -->
    <main-menu v-vue-sticky="{zIndex: 1000, stickyTop: 0}"></main-menu> <!-- 동적 메뉴 아이템,  -->
      <router-view name="home" key="home"></router-view>  <!-- multisections -->
      <router-view name="vod" key="vod"></router-view>  <!-- multisections -->
      <router-view name="live" key="live"></router-view>  <!-- multisections -->
      <router-view name="movie" key="movie"></router-view>  <!-- multisections -->
      <router-view name="global" key="global"></router-view>  <!-- multisections -->
<!--    <router-view name="clip" key="clip"></router-view>  &lt;!&ndash; multisections &ndash;&gt;-->
    <Oval/>
  </div>
</template>
<script>
// FOOTER는 HOME.vue 에서만..
import Header from '@/components/header/Header'
import MainMenu from '@/components/header/MainMenu'
import { mapGetters, mapMutations } from 'vuex'
import MainHeader from '@/components/header/template/MainHeader'
import VueSticky from 'vue-sticky'
import Oval from '@/components/Oval'
import LnbWrapper from '@/components/lnb/LnbWrapper'
import utils from '@/common/util/utils'

export default {
  name: 'HomeLayout',
  components: {
    LnbWrapper,
    MainHeader,
    MainMenu,
    Header,
    Oval
  },
  data () {
    return {
      showHomeLayout: true
    }
  },
  methods: {
    ...mapMutations({
      showLnb: 'showLnb',
      resetSearchState: 'resetSearchState',
      showCategorySearch: 'showCategorySearch',
      showUserProfile: 'showUserProfile',
      hideUserProfile: 'hideUserProfile',
      hideLnb: 'hideLnb'
    }),
    showUserInfo () {
      this.hideLnb()
      this.showUserProfile()
    },
    closeUserInfo () {
      this.hideUserProfile()
    },
    closeLnb (e) {
      this.hideLnb()
    }
  },
  directives: {
    VueSticky
  },
  computed: {
    ...mapGetters(['isPooqZone', 'currentGNBInfo', 'currentMenu', 'lnbStatus',
      'isVisibleUserProfile', 'isVisibleAlarms', 'isBandLoading' ])
  },
  created () {}
}
</script>
<style>
  .app-wrapper {
    position: relative;
    width: 100%;
    background-color: #1b1b1b;
    min-height: 100vh;
  }
</style>
